"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var typeWriter_1 = require("./typeWriter");
var writter = new typeWriter_1.default();
function useTypeWritter(str) {
    var _a = react_1.useState(null), word = _a[0], setWord = _a[1];
    var intervalRef = react_1.useRef({});
    var strRef = react_1.useRef({});
    react_1.useEffect(function () {
        strRef.current = setWord(writter.startTypeWord(str));
    }, [str]);
    react_1.useEffect(function () {
        intervalRef.current = setInterval(function () {
            setWord(writter.typing());
        }, writter.rd());
        return function clear() {
            clearInterval(intervalRef.current);
        };
    }, [word]);
    return word;
}
exports.default = useTypeWritter;
//# sourceMappingURL=useTypewriter.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-typewriter-hook/build/useTypewriter.js
// module id = 1001
// module chunks = 0